
/* styles */
require("!!vue-style-loader!happypack/loader?id=css!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-5b2140f4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./toggleswitch.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!happypack/loader?id=babel!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./toggleswitch.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5b2140f4\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./toggleswitch.vue"),
  /* scopeId */
  "data-v-5b2140f4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/common/toggleswitch.vue
// module id = 543
// module chunks = 23